<template>
  <div v-if="userData!==null">
    <b-card
      dir="rtl"
    >
      <b-row>
        <!-- User Info: Left col -->
        <b-col
          cols="21"
          xl="6"
          class="d-flex justify-content-between flex-column"
        >
          <!-- User Avatar & Action Buttons -->
          <div class="d-flex justify-content-start">
            <b-avatar
              :src="userData.Image"
              size="104px"
              rounded
            />
            <div class="d-flex flex-column ml-1">
              <div class="mb-1">
                <h4 class="mb-0">
                  <template v-if="userData.Name || userData.Family">
                    {{ userData.Name }} {{ userData.Family }}
                  </template>
                  <template v-else>
                    کاربر زیره
                  </template>
                </h4>
                <span class="d-block card-text">
                  {{ userData.Email }}
                  <feather-icon
                    v-if="userData.Email"
                    icon="CheckIcon"
                    size="21"
                    :class="{ 'text-success' : userData.IsEmailActive }"
                  />
                </span>
                <span class="d-block card-text">{{ userData.Mobile }}
                  <feather-icon
                    v-if="userData.Mobile"
                    icon="CheckIcon"
                    size="21"
                    :class="{ 'text-success' : userData.IsMobileActive }"
                  />
                </span>
              </div>
            </div>
          </div>

          <!-- User Stats -->
        </b-col>

        <!-- Right Col: Table -->
        <b-col
          cols="12"
          xl="6"
        >
          <table class="mt-2 mt-xl-0 w-100">
            <tr>
              <th
                class="pb-50"
                style="width: 150px"
              >
                <feather-icon
                  icon="FlagIcon"
                  class="mr-75"
                />
                <span class="font-weight-bold">شهر</span>
              </th>
              <td class="pb-50">
                {{ userData.City }}
              </td>
            </tr>
            <tr>
              <th class="pb-1">
                <feather-icon
                  icon="GlobeIcon"
                  class="mr-75"
                />
                <span class="font-weight-bold">زبان کاربر</span>
              </th>
              <td class="pb-1 d-flex">
                <v-select
                    v-model="userLanguage"
                    :options="enums('Language')"
                    :dir="$dir"
                    label="text"
                    :clearable="false"
                    name="Language"
                    class="select-size-sm mr-50"
                    style="width: 130px"
                    :reduce="x => x.value"
                />
                <b-button
                    size="sm"
                    variant="primary"
                    :disabled="userLanguage === userData.Language"
                    class="btn-icon"
                    style="padding: 5px;line-height: 5px"
                    @click="updateLanguage"
                >
                  <feather-icon icon="CheckIcon" />
                </b-button>
              </td>
            </tr>
            <tr>
              <th>
                <feather-icon
                  icon="ClockIcon"
                  class="mr-75"
                />
                <span class="font-weight-bold">تاریخ ثبت نام</span>
              </th>
              <td>
                {{ userData.CreatedAt | date }}
              </td>
            </tr>
          </table>
        </b-col>
      </b-row>
    </b-card>
    <b-card
      border-variant="dark"
    >
      <b-card-body>
        <b-card-title>وضعیت اعلان ها</b-card-title>
        <div class="d-flex flex-row ">
          <div v-for="item in notificationStatuses" class="mr-3 d-inline-flex d-flex-column">
            <p class="mr-1" v-text="item.Title" />
            <p>
              <b-badge
                :variant="item.IsActive ? 'success' : 'danger'"
              >
                {{ item.IsActive ? 'فعال' : 'غیرفعال' }}
              </b-badge>
            </p>
          </div>
        </div>
      </b-card-body>
    </b-card>
    <b-card
      border-variant="dark"
      title="تنظیمات"
    >
      <b-row>
          <b-col md="3">
            <b-form-group
                label="نام"
                label-for="Name"
            >
              <b-form-input
                  v-model="userData.Name"
                  autocomplete="off"
              />
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group
                label="نام خانوادگی"
                label-for="Family"
            >
              <b-form-input
                  v-model="userData.Family"
                  autocomplete="off"
              />
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group
                label="وضعیت"
                label-for="IsActive"
            >
              <v-select
                  v-model="userData.IsActive"
                  :options="enums('IsActive')"
                  dir="rtl"
                  label="text"
                  :reduce="x => x.value"
                  :clearable="false"
              />
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group
              label="قفل"
              label-for="IsLock"
          >
            <v-select
                v-model="userData.IsLock"
                :options="enums('IsActive')"
                dir="rtl"
                label="text"
                :reduce="x => x.value"
                :clearable="false"
            />
          </b-form-group>
          </b-col>
        <b-col cols="12">
          <b-form-group label="توضیحات" label-for="Description">
            <b-form-textarea
                v-model="userData.Description"
                rows="1"
                max-rows="8"
            />
          </b-form-group>
        </b-col>

        <b-col md="3">
          <b-form-group
              label="وضعیت زیره پلاس"
              label-for="Status"
          >
            <v-select
                v-model="userData.Status"
                :options="enums('UserStatus')"
                dir="rtl"
                label="text"
                :reduce="x => x.value"
                :clearable="true"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group label="پیام" label-for="Message">
            <b-form-textarea
                v-model="userData.Message"
                rows="1"
                max-rows="8"
            />
          </b-form-group>
        </b-col>

        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          type="submit"
          variant="primary"
          @click="save"
        >
          ذخیره
        </b-button>
      </b-row>
    </b-card>
    <b-card
        v-if="$can( 'show','UserRoleManager')"
        border-variant="dark"
    >
      <b-card-body>
        <b-card-title>نقش</b-card-title>
        <div class="d-flex flex-row">
                    <b-form-group class="mr-1 mb-0">
                      <UserRole
                        v-model="userData.UserRoleId"
                        style="width:200px"
                      />
                    </b-form-group>
          <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="submit"
              variant="primary"
              @click="assign"
          >
            ذخیره
          </b-button>
        </div>

      </b-card-body>
    </b-card>
    <b-card
      border-variant="dark"
    >
      <b-card-title>ایجاد کد فعال ساز</b-card-title>
      <div
        style="width:300px"
        class="d-inline-block"
      >
        <b-input-group>
          <b-input-group-prepend>
            <b-button
              variant="outline-primary"
              :loading="true"
              @click="makeVerifyCode()"
            >
              ایجاد
            </b-button>
          </b-input-group-prepend>
          <b-form-input
            v-model="verifyCode"
            type="number"
            placeholder="نمونه:1234"
          />
        </b-input-group>
      </div>
    </b-card>
  </div>
</template>
<script>
import {
  BCard, BAvatar, BRow, BCol, BBadge, BCardBody,
  BCardTitle,
} from 'bootstrap-vue'
import UserRole from '@/tools/userrole.vue'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BAvatar,
    BBadge,
    UserRole,
    BCardBody,
    BCardTitle,
  },
  props: {
    userId: {
      type: [Number, String],
      default: null,
    },
    userData: { type: Object, default: null }
  },
  data() {
    return {
      verifyCode: null,
      loading: false,
      userLanguage: '',
      notificationStatuses: []
    }
  },
  watch: {
    loading(val) {
      this.$emit('loading', val)
    },
    userData: {
      immediate: true,
      handler(val) {
        if (val) this.userLanguage = val.Language
      }
    }
  },
  created() {
    this.getNotifications()
  },
  methods: {
    makeVerifyCode() {
      this.$http.post(this.$api.authentication.verifyCode, {
        Code: this.verifyCode,
        Id: this.userData.Id,
      })
    },
    save() {
      this.$http.post(this.$api.user.update, {
        Id: this.userData.Id,
        Name: this.userData.Name,
        Family: this.userData.Family,
        IsActive: this.userData.IsActive,
        Description: this.userData.Description,
        IsLock: this.userData.IsLock,
        Message: this.userData.Message,
        Status: this.userData.Status,
      })
    },
    assign() {
      this.$http.post(this.$api.userrole.assign, {
        UserId: this.userData.Id,
        Id: this.userData.UserRoleId,
      })
    },
    updateLanguage() {
      this.$http.post(this.$api.user.userLanguage, {
        UserId: this.userData.Id,
        Language: this.userLanguage,
      })
    },
    getNotifications() {
      this.$http.post(this.$api.user.userNotifications, {}).then(response => {
        this.notificationStatuses = response.data
      })
    }
  },
}
</script>
